import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { BaseApiPublicLoginTemplateService } from '../../shared/base-api-public-login-template.service';
import { WfIssueLabelModel } from '../../../../../../models/aggregates/wf/issue/wf-issue-label-container.model';
import {BaseApiTemplateService, Core2Config} from '../../shared';
import { ApiResponseModel } from '../../shared/api-response.model';
import { ApiVisa } from '../../shared/api-visa.model';
import {WfIssueLabelCriteriaClass, WfIssueLabelCriteriaModel} from "../../../criteria/wf/issue/index";
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class WfIssueLabelService extends BaseApiTemplateService<WfIssueLabelModel> {

  readonly url =  Core2Config.DOMAIN_TEST_URL + Core2Config.DOMAIN_URL_PREFIX + Core2Config.WF_PREFIX + 'issue-labels';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_TEST_URL + Core2Config.DOMAIN_URL_PREFIX + Core2Config.WF_PREFIX + 'issue-labels';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.WF_PREFIX + 'issue-labels';
    this.httpClient = http;
  }


  getPromiseByCriteria(
    visa: ApiVisa, criteria?: WfIssueLabelCriteriaClass
  ): Promise<ApiResponseModel<WfIssueLabelModel>> {
    const buildDocCriteria = new WfIssueLabelCriteriaModel(criteria);
    console.log('buildDocCriteria: ', buildDocCriteria);
    console.log('OverRide: ', buildDocCriteria.query);
    const UrlByCriteria = this.apiUrl + '/query?' + buildDocCriteria.query;
    return this.httpClient.get<ApiResponseModel<WfIssueLabelModel>>
      (UrlByCriteria, this.getHttpHeader(visa))
      .toPromise();
  }

  getByCriteriaObservable(
    visa: ApiVisa, criteria?: WfIssueLabelCriteriaClass
  ): Observable<ApiResponseModel<WfIssueLabelModel>> {
    const buildDocCriteria = new WfIssueLabelCriteriaModel(criteria);
    const apiUrl = visa.api_domain_url + this.endpoint_path;
    const UrlByCriteria = apiUrl + '/query?' + buildDocCriteria.query;
    return this.httpClient.get<ApiResponseModel<WfIssueLabelModel>>
      (UrlByCriteria, this.getHttpHeader(visa));
  }


  updateImageAndDetails(formData: FormData, imageGuid, httpOptions) {
    const url = this.apiUrl + '/replace-file/' + imageGuid;
    return this.httpClient.put(url, formData, httpOptions);
  }

  replaceImageAndDetails(formData: FormData, imageGuid, visa: ApiVisa) {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    const url = this.apiUrl + '/replace-file/' + imageGuid;
    return this.httpClient.put(url, formData, this.getHttpHeader(visa));
  }

  uploadImageAndDetails(formData: FormData, subjectGuid, httpOptions) {
    const url = this.apiUrl + '/add-files/' + subjectGuid;
    return this.httpClient.put(url, formData, httpOptions);
  }

  addImageAndDetails(formData: FormData, subjectGuid, visa: ApiVisa) {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    const url = this.apiUrl + '/add-files/' + subjectGuid;
    return this.httpClient.put(url, formData, this.getHttpHeader(visa));
  }
  getImageDetails(imageGuid, visa: ApiVisa) {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    const url = this.apiUrl + '/file/' + imageGuid;
    return this.httpClient.get(url, this.getHttpHeader(visa));
  }
  deleteImageDetails(imageGuid, visa: ApiVisa) {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    const url = this.apiUrl + '/file/' + imageGuid;
    return this.httpClient.delete(url, this.getHttpHeader(visa));
  }

  public getFile(extGuid: string, visa: ApiVisa): Observable<Blob> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    const url = this.apiUrl + '/file/' + extGuid;

    return this.httpClient.get<Blob>(
      url,
      {
        headers: new HttpHeaders({
          authorization: visa.jwt_secret,
          responseType: 'blob',
          tenantCode: visa.tenantCode
        }),
        responseType: 'blob' as 'json'
      });
  }
}
